<template>
    <img
        :src="img"
        :alt="iso"
        @error="test(false)"
        @load="test(true)"
    >
</template>

<script>
import ErrorHandler from "@/utils/errorHandler";

export default {
    name: 'flag',

    props: {
        iso: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true,
            validator(value) {
                return ['country', 'language'].includes(value.toLowerCase())
            }
        }
    },

    data() {
        return {
            img: '',
            inc: {}
        }
    },

    watch: {
        iso() {
            this.initFlag()
        }
    },

    methods: {
        test(bool) {
            if (!bool) {
                this.img = `../images/flags/no-flag.png`
            }
        },

        initFlag() {
            try {
                let iso = this.iso.toLowerCase()
                let folder = ''

                if (this.type.toLowerCase() === 'country') {
                    folder = 'flags'
                }

                if (this.type.toLowerCase() === 'language') {
                    folder = 'fl_languages'
                }

                this.img = `../images/${folder}/${iso}.png`
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    mounted() {
        this.initFlag()
    }
}
</script>
